/** Announced when the user adds, edits or removes an account of the connection hub. */
export const CONNECTIONS_CHANGED_EVENT = 'crowdex-connections-changed';

export function announceConnectionsChanged(): void {
  window.dispatchEvent(new Event(CONNECTIONS_CHANGED_EVENT));
}
